export function hasDoctorCareers(careers: unknown): careers is number {
  return typeof careers === "number" && Number.isFinite(careers) && careers > 0
}
